import React from "react"
import { useTranslation } from "react-i18next"

import { getCheckoutPaymentInfo, thousandSeparator } from "utils"
import classes from "./OfflineOrderDetailsFooter.module.scss"

const OfflineOrderDetailsFooter = props => {
  const { offlineOrder } = props

  const [t] = useTranslation()

  const {
    total,
    subtotal,
    taxesAndCharges,
    totalFoodCouponDiscount,
    totalSystemDiscounts,
    totalDeliveryDiscountByCoupon,
  } = getCheckoutPaymentInfo(
    offlineOrder.order.items,
    offlineOrder.order.combos,
    offlineOrder.discounts,
    offlineOrder.deliveryFees,
    offlineOrder.deliveryType
  )

  return (
    <div className={classes["container"]}>
      <div className={classes["totalItem"]}>
        <div>{t("مجموع_اقلام")}</div>
        <div className={classes["number"]}>
          {thousandSeparator(subtotal)}
        </div>
      </div>

      {
        offlineOrder.deliveryType === "delivery" &&
        <div className={classes["deliveryFeeContainer"]}>
          <div className={classes["deliveryFee"]}>
            <div>{t("هزینه_ارسال")}</div>
            <div className={classes["number"]}>
              {thousandSeparator(offlineOrder.deliveryFees?.fee)}
            </div>
          </div>
          <div className={classes["deliveryService"]}>
            <div>{t("ارسال")}</div>
            {offlineOrder.deliveryService === "snapbox"
              ?
              <img
                className={classes["snapbox"]}
                src="/assets/images/snappbox-logo.png"
                alt=""
              />
              :
              <div className={classes["seakitchen"]}>
                {offlineOrder.areaName}
              </div>
            }
          </div>
        </div>
      }

      {
        totalSystemDiscounts > 0 &&
        <div className={classes["totalItem"]}>
          <div>{t("تخفیف_صندوقدار")}</div>
          <div className={classes["number"]}>
            {thousandSeparator(-totalSystemDiscounts)}
          </div>
        </div>
      }

      {
        totalFoodCouponDiscount > 0 &&
        <div className={classes["totalItem"]}>
          <div>{t("تخفیف_کالا")}</div>
          <div className={classes["number"]}>
            {thousandSeparator(-totalFoodCouponDiscount)}
          </div>
        </div>
      }

      {
        totalDeliveryDiscountByCoupon > 0 &&
        <div className={classes["totalItem"]}>
          <div>{t("تخفیف_ارسال")}</div>
          <div className={classes["number"]}>
            {thousandSeparator(-totalDeliveryDiscountByCoupon)}
          </div>
        </div>
      }

      {taxesAndCharges.map(tax =>
        <div
          key={tax.title}
          className={classes["totalItem"]}
        >
          <div className={classes["title"]}>
            {tax.title}{" "}
            {tax.isPercentageModel ? `(${tax.percentage}%)` : ""}
          </div>
          <div className={classes["number"]}>
            {thousandSeparator(tax.amount)}
          </div>
        </div>
      )}

      <div className={classes["total"]}>
        <div>{t("مجموع")}</div>
        <div className={classes["totalNumber"]}>
          {thousandSeparator(total)}
        </div>
      </div>
    </div>
  )
}

export default OfflineOrderDetailsFooter